<div class="width-100">
  <router-outlet></router-outlet>
</div>



